export default{
    newsOneTitle: 'Fintech loan interest fell by 50%, loan players were selective in choosing prospective borrowers',
    newsOneTime: "pubdate",
    newsOneRead:"Pageviews",
    newsOneSource:"Article source:",
    newsOneDetail:[
        {
            p:'Reporter: Selvi Mayasari | Editor: Yudho Winarto'
        },
        {
            p:"Monday, 25 October 2021 / 06:20 WIB"
        },
        {
            p:"KONTAN.CO.ID - JAKARTA. The Indonesian Joint Funding Association (AFPI) has agreed to cut the upper limit of the maximum online loan interest rate (pinjol) to approximately 50% of the daily loan interest rate of 0.8% maximum."
        },
        {
            p:"This means that customer loan interest will decrease to 0.4% per day. This is an effort to make online loans more affordable with economies of scale, as well as an effort to deal with illegal loans."
        },
        {
            p:"These steps are taken to make the fintech industry healthier. So that people can distinguish between illegal and official fintech, especially at very competitive prices."
        },
        {
            p:"One of the P2P lending fintech players, DanaRupiah, supports this decision. President Director of DanaRupiah Entjik S. Djafar stated that the impact on disbursement will definitely decrease, because his party will be very conservative in choosing borrowers."
        },
        {
            p:"'We prefer existing customers, whose risks can already be covered,' said Entjik to kontan.co.id, Sunday (24/10)."
        },
        {
            p:"Regarding whether there is still room to lower loan interest rates, Entjik admits, there is no room for it to go down, if it is lowered again he believes that everything will stop in this business."
        },
        {
            p:"Entjik said, for now his party does not want to be aggressive in distributing loans, adding new customers is also avoided. 'We still prioritize existing customers, whose payments or risks are clear,' said Entjik."
        },
        {
            p:"The peer-to-peer (P2P) lending financial technology platform PT Amartha Mikro Fintek (Amartha) also stated that it supports policies that can create a healthy business ecosystem for fintech players and the general public as customers/consumers."
        },
        {
            p:'"Hopefully, with regulations that can create a safe, comfortable, and mutually beneficial ecosystem, people can use fintech services better, so that financial inclusion can continue to be improved," said CEO and Founder of Amartha Andi Taufan Garuda Putra.'
        },
        {
            p:"It ensures that borrowers do not experience overdebt by conducting analysis using machine learning technology. So that the results are more accurate, and according to the borrower's ability to pay."
        },
        {
            p:'"So, it is Amartha‘s principle to determine the amount of interest in accordance with the ability to pay of the borrowers, regardless of whether or not this new regulation exists," he said.'
        },
        {
            p:"Andi explained, Amartha will continue to maintain loan quality by utilizing technology. By adopting a hybrid system (a combination of online and offline), Amartha remains optimistic that it can maintain healthy financial performance."
        },
        {
            p:"In addition, Amartha also expands synergistic collaboration with various institutions such as banking, to jointly provide access to capital for MSMEs in Indonesia."
        },
        {
            p:'"Collaboration with institutions really helps Amartha to continue to grow and can expand the reach of capital to more borrowers or female micro-entrepreneur partners in rural areas," said Andi.'
        },
    ]
}